module.exports = __webpack_public_path__ + "static/patagonia-67fa39f3bdc01afd81e01c7d448259be.png";